import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/videos/video.h264.mp4")